<template>
	<div class="product-badges mb-3">
		<badge-cod :is-cod-enabled="isCodEnabled" class="mr-2"></badge-cod>
		<badge-private :is-private-enabled="isPrivateEnabled" class="mr-2"></badge-private>
		<badge-deleted :is-deleted="isDeletedProduct" class="mr-2"></badge-deleted>
		<badge-lp :is-lp-enabled="isLpEnabled" class="mr-2"></badge-lp>
		<badge-marketing-kit :is-marketing-kit-enabled="isMarketingKitEnabled" class="mr-2"></badge-marketing-kit>
	</div>
</template>

<script>
import BadgeCod from '@/components/products/BadgeCod.vue';
import BadgePrivate from '@/components/products/BadgePrivate.vue';
import badgeLp from '@/components/products/BadgeLp.vue';
import badgeMarketingKit from '@/components/products/BadgeMarketingKit.vue';
import badgeDeleted from '@/components/products/BadgeDeleted.vue';

export default {
	name: 'Badges',
	components: {
		BadgeCod,
		BadgePrivate,
		badgeLp,
		badgeMarketingKit,
		badgeDeleted,
	},
	props: {
		isCodEnabled: {
			type: Boolean,
			default: false,
		},
		isPrivateEnabled: {
			type: Boolean,
			default: false,
		},
		isLpEnabled: {
			type: Boolean,
			default: false,
		},
		isMarketingKitEnabled: {
			type: Boolean,
			default: false,
		},
		isDeletedProduct: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.product-badges {
	height: 16px;
	text-align: left;
}
</style>
